import {
  Button,
  Dialog,
  FormControl,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  Typography,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import React, { useState } from "react";
import { FormattedMessage } from "react-intl";
import styled from "styled-components";
import cuideoTheme from "../../../../../../containers/themes/defaultTheme";
import {
  ContractDemoteReason,
  CONTRACT_DEMOTE_REASONS,
} from "../../domain/contract-demote-reason";

const StyledDialog = styled(Dialog)`
  .MuiDialog-paper {
    min-width: 28rem;
  }
`;

const StyledHeader = styled.div`
  background-color: #cdd5d8;
  color: ${cuideoTheme.palette.primary.main};
  padding: 0.75rem 1rem;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

const StyledTitle = styled(Typography)`
  font-weight: 700;
  font-size: 1.25rem;
`;

const StyledIconButton = styled(IconButton)``;

const StyledContent = styled.div`
  padding: 1.25rem 1rem;
`;

const StyledQuestion = styled(Typography)`
  margin-bottom: 1rem;
  font-size: 1rem;
`;

const StyledFormControl = styled(FormControl)`
  min-width: 100%;
  margin-bottom: 1.25rem;
`;

const StyledActions = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  gap: 0.75rem;
`;

const REASON_MESSAGE_IDS: Record<ContractDemoteReason, string> = {
  client_rejects_profile:
    "ContractDemoteToRecruiterModal.Cliente no acepta perfil",
  client_requests_2nd_profile:
    "ContractDemoteToRecruiterModal.Cliente solicita 2º perfil",
  client_requests_new_profile_conditions_change:
    "ContractDemoteToRecruiterModal.Cliente solicita perfil nuevo por cambio de condiciones",
  advisor_rejects_profile:
    "ContractDemoteToRecruiterModal.Asesor no acepta perfil",
  caregiver_self_withdraws:
    "ContractDemoteToRecruiterModal.Cuidador se autodescarta",
};

export interface ContractDemoteToRecruiterModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: (reason: ContractDemoteReason) => void;
}

const ContractDemoteToRecruiterModal: React.FC<
  ContractDemoteToRecruiterModalProps
> = (props) => {
  const { open, onClose, onConfirm } = props;
  const [selectedReason, setSelectedReason] =
    useState<ContractDemoteReason | "">("");

  const handleContinue = () => {
    if (selectedReason) {
      onConfirm(selectedReason as ContractDemoteReason);
      setSelectedReason("");
      onClose();
    }
  };

  const handleClose = () => {
    setSelectedReason("");
    onClose();
  };

  return (
    <StyledDialog open={open} onClose={handleClose}>
      <StyledHeader>
        <StyledTitle color="primary">
          <FormattedMessage
            id="ContractDemoteToRecruiterModal.¿Por qué quieres devolver el contrato al recruiter?"
            defaultMessage="¿Por qué quieres devolver el contrato al recruiter?"
          />
        </StyledTitle>
        <StyledIconButton color="primary" onClick={handleClose}>
          <CloseIcon />
        </StyledIconButton>
      </StyledHeader>
      <StyledContent>
        <StyledQuestion color="textSecondary">
          <FormattedMessage
            id="ContractDemoteToRecruiterModal.Selecciona el motivo"
            defaultMessage="Selecciona el motivo"
          />
        </StyledQuestion>
        <StyledFormControl variant="outlined" size="small">
          <InputLabel id="contract-demote-reason-label">
            <FormattedMessage
              id="ContractDemoteToRecruiterModal.Motivo"
              defaultMessage="Motivo"
            />
          </InputLabel>
          <Select
            labelId="contract-demote-reason-label"
            value={selectedReason}
            onChange={(e) =>
              setSelectedReason(e.target.value as ContractDemoteReason)
            }
            label="Motivo"
          >
            {CONTRACT_DEMOTE_REASONS.map((reason) => (
              <MenuItem key={reason} value={reason}>
                <FormattedMessage
                  id={REASON_MESSAGE_IDS[reason]}
                  defaultMessage={reason}
                />
              </MenuItem>
            ))}
          </Select>
        </StyledFormControl>
        <StyledActions>
          <Button variant="outlined" color="primary" onClick={handleClose}>
            <FormattedMessage
              id="ContractDemoteToRecruiterModal.Cancelar"
              defaultMessage="Cancelar"
            />
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={handleContinue}
            disabled={!selectedReason}
          >
            <FormattedMessage
              id="ContractDemoteToRecruiterModal.Continuar"
              defaultMessage="Continuar"
            />
          </Button>
        </StyledActions>
      </StyledContent>
    </StyledDialog>
  );
};

export default ContractDemoteToRecruiterModal;
